import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { debugModeArgument } from "utils/debugModeArgument";

const FilterGroup = (props) => {
  const {
    filters = [],
    name,
    title,
    isActive = true,
    actionUrl,
    stretchThreshold = 2,
    isTitleDisabled,
    isLeftPlaced,
    count,
    forceActive = false,
  } = props;
  const componentBaseClass = "sal-filtergroup";
  const className = classnames(
    componentBaseClass,
    { [`${componentBaseClass}--active`]: isActive || forceActive },
    { [`${componentBaseClass}--inactive`]: !isActive && !forceActive },
    { [`${componentBaseClass}--stretch`]: filters.length > stretchThreshold },
    { [`${componentBaseClass}--stick-left`]: isLeftPlaced },
  );
  const formClassName = `${componentBaseClass}__filter-container`;

  if (!isActive || (count === 0 && !forceActive)) {
    return null;
  }
  return (
    <section
      className={className}
      data-cv-debug={debugModeArgument("true")}
      data-cv-debug-system={debugModeArgument("SAL")}
      data-cv-debug-component={debugModeArgument("FilterGroup")}
    >
      {title && !isTitleDisabled && (
        <h1 className={`${componentBaseClass}__title`}>{title}</h1>
      )}
      <form
        className={formClassName}
        id={`${componentBaseClass}__${name}`}
        action={actionUrl}
        method="get"
      >
        {filters}
      </form>
    </section>
  );
};

FilterGroup.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  filters: PropTypes.array,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  stretchThreshold: PropTypes.number,
  isTitleDisabled: PropTypes.bool,
  isLeftPlaced: PropTypes.bool,
  count: PropTypes.number,
  forceActive: PropTypes.bool,
};

export default FilterGroup;
